import { useMemo, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import { ToolCard } from '@/components/tools/ToolCard';
import { PageHeader } from '@/components/ui/PageHeader';
import { AVAILABLE_TOOLS, getToolsByGroup } from '@/data/tools';

export default function Tools() {
  const [searchTerm, setSearchTerm] = useState('');

  const groups = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    const matching = term
      ? AVAILABLE_TOOLS.filter(
          (tool) => tool.name.toLowerCase().includes(term) || tool.description.toLowerCase().includes(term)
        )
      : AVAILABLE_TOOLS;
    return getToolsByGroup(matching);
  }, [searchTerm]);

  return (
    <div className="tools-page">
      <PageHeader
        title="Tools"
        actions={
          <InputGroup style={{ width: 300 }}>
            <InputGroup.Text>
              <Search />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder="Search tools"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Search tools"
              autoFocus
            />
          </InputGroup>
        }
      />

      {groups.length === 0 && <p className="text-muted">No tool matches that search.</p>}

      {groups.map((group) => (
        <section key={group.id} className="mb-4">
          <h2 className="section-label">{group.name}</h2>
          <div className="tool-grid">
            {group.tools.map((tool) => (
              <ToolCard key={tool.id} tool={tool} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
